























































import { Component, Prop, Vue } from 'vue-property-decorator';
import { ShopFilter } from '@/types';

@Component
export default class FilterPopup extends Vue {
  @Prop() private shopFilter!: ShopFilter;

  private model: ShopFilter = {
    currentlyOpen: this.shopFilter.currentlyOpen,
    curbsidePickup: this.shopFilter.curbsidePickup,
  }

  private clear(): void {
    this.model = {
      curbsidePickup: false,
      currentlyOpen: false,
    };
  }
}
